const capitalizeWord = (word) => [...word].map((l, i) => (i ? l : l.toUpperCase())).join('');
const getWords = (sentence, divider = /\s+/) =>
  sentence
    .split(divider)
    .map((w) => w.trim())
    .filter((w) => w.length);

export { capitalizeWord, getWords };
